<template>
  <div class="cosechar container mt-4">
    <h2 class="mb-4">
       Cosechar Producto 
    </h2>
    <form @submit.prevent="procesarCosecha" class="p-4 shadow bg-white rounded">

      <!-- Paso 1: Selección de Lote y Plantas -->
      <div class="step-section mb-4">
        <div class="step-header mb-2">
          <span class="badge bg-primary me-2">Paso 1</span>
          <span class="h5">Selección de Plantas por Lote</span>
        </div>
        <!-- Se evita que los clics en el componente de selección propaguen el evento submit -->
        <div class="mb-3">
          <seleccionarplantasLote 
            :lote-id="filtros.loteId" 
            :estadosFiltrados="[
                'Viva',                  // La planta está en funcionamiento.
                'Lista para cosechar',    // La planta está lista para ser recolectada.
                'Dañada',                // La planta presenta daños que afectan su rendimiento.
                'Enferma',               // La planta está afectada por alguna enfermedad.
                ]"
            @plantas-seleccionadas="confirmarSeleccionPlantas" 
          />

          <div v-if="form.plantas.length" class="alert alert-warning mt-3">
            <font-awesome-icon icon="fas fa-exclamation-triangle" class="me-2" />
            <strong>Atención:</strong> Las plantas seleccionadas pasaran al estado Cosechada y no podrán ser usadas nuevamente.
          </div>
        </div>
      </div>

      <!-- Paso 2: Información del Producto -->
      <div class="step-section mb-3">
        <div class="step-header mb-2">
          <span class="badge bg-secondary me-2">Paso 2</span>
          <span class="h5">Información del Producto</span>
        </div>
        <div class="seccion-producto">
          <div class="mb-3">
            <label for="tipo" class="form-label">Tipo de Producto:</label>
            <select id="tipo" v-model="form.tipo" class="form-select" required>
              <option value="" disabled>Selecciona un tipo</option>
              <option v-for="tipo in tipos" :key="tipo" :value="tipo">
                {{ tipo }}
              </option>
            </select>
          </div>
  

  
          <div class="mb-3">
            <label for="nombre" class="form-label">Nombre del Producto:</label>
            <input type="text" id="nombre" v-model="form.nombre" class="form-control" placeholder="Ingresa el nombre del producto" required />
          </div>
  
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="cantidad" class="form-label">Cantidad:</label>
              <input type="number" id="cantidad" v-model="form.cantidad" class="form-control" placeholder="Ingresa la cantidad" required min="0.1" step="0.1" />
            </div>
            <div class="col-md-6">
              <label for="unidad_medida" class="form-label">Unidad de Medida:</label>
              <select id="unidad_medida" v-model="form.unidad_medida" class="form-select" required>
                <option value="" disabled>Selecciona una unidad de medida</option>
                <option v-for="unidad in unidades" :key="unidad" :value="unidad">
                  {{ unidad }}
                </option>
              </select>
            </div>
          </div>

           <!-- Campo Nombre y Código -->
          <div class="mb-3 qr-update-section">
            <!-- Contenedor del QR con diseño personalizado -->
            <div v-if="form.codigo" class="qr-container me-3">
              <qrcode-vue :value="form.codigo" :size="128" />
              <div class="qr-code-label">{{ form.codigo }}</div>
            </div>
            <!-- Botón de actualización con icono -->
            <button type="button" class="btn btn-outline-secondary" @click="generarCodigo">
              <font-awesome-icon :icon="['fas','sync']" class="me-1" />
              Actualizar QR
            </button>
          </div>



        </div>
      </div>
  
      <!-- Botones Finales -->
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary me-3" @click="cerrarFormulario">
          Cancelar
        </button>
        <button type="submit" class="btn btn-success">
          Cosechar Producto
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import seleccionarplantasLote from "../Lote/seleccionarplantasLote.vue";
import axios from "@/axios";
import QrcodeVue from "qrcode.vue";

export default {
  name: "CosecharPlanta",
  components: {
    seleccionarplantasLote,
    QrcodeVue,
  },
  props: {
    proyecto_id: {
      type: Number,
      required: true,
    },
    proyecto_evento_id: {
      type: Number,
      required: true,
    },

  },

  data() {
    return {
      clubActual: null,
      form: {
        nombre: "",
        tipo: "",
        cantidad: null,
        unidad_medida: "",
        plantas: [],
        codigo: "",
      },
      filtros: {
        estado: "",
        loteId: "",
      },
      tipos: [],
      unidades: [],
      lotes: [],
      estadosLote: ['Activo', 'Cosechado', 'Inactivo'],
    };
  },
  computed: {
    lotesFiltrados() {
      if (!this.filtros.estado) return this.lotes;
      return this.lotes.filter(lote => lote.estado === this.filtros.estado);
    },
  },
  methods: {
    async generarCodigo() {
      try {
        const response = await axios.get("/api/producto_final_codigo/"+this.clubActual.id,{headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }});
        this.form.codigo = response.data;
        
      } catch (error) {
        console.error("Error al generar el código:", error);
        alert("No se pudo generar el código. Por favor, intenta nuevamente.");
      }
    },
    async cargarTipos() {
      try {
        const response = await axios.get("/api/constantes/tipos_de_productos_derivados_de_cannabis");
        this.tipos = response.data;
      } catch (error) {
        console.error("Error al cargar los tipos:", error);
      }
    },
    async cargarUnidades() {
      try {
        const response = await axios.get("/api/constantes/unidades-medida");
        this.unidades = response.data.filter(unidad =>
          ["unidad", "cm3", "dcm3", "litros", "gramos", "kilos", "mililitros", "miligramos"].includes(unidad)
        );
      } catch (error) {
        console.error("Error al cargar las unidades de medida:", error);
      }
    },
    async cargarLotes() {
      try {

        const response = await axios.get("/api/proyectos/"+this.proyecto_id+"/lotes_cosechar", {
          params: { club_id: this.clubActual.id },
        });
        this.lotes = response.data;
      } catch (error) {
        console.error("Error al cargar los lotes:", error);
      }
    },
    confirmarSeleccionPlantas(plantas) {
      this.form.plantas = plantas;
    },
    resetFormulario() {
      this.form = {
        nombre: "",
        tipo: "",
        cantidad: null,
        unidad_medida: "",
        plantas: [],
        codigo: "",
      };
      this.filtros = {
        estado: "",
        loteId: "",
      };
    },
    cerrarFormulario() {
      this.resetFormulario();
      this.$emit("cerrar");
    },
    async procesarCosecha() {
      try {
        const payload = {
          ...this.form,
          plantas: this.form.plantas?.map(planta => planta.id),
          lote: this.filtros.loteId,
          club_id: this.clubActual.id,
        };
  
       
        let plantasSeleccionadas = this.form.plantas?.map(planta => planta.codigo).join(", ");
        const confirmacion = `¿Estás seguro de crear el producto con las siguientes plantas? ${plantasSeleccionadas}`;
        if (!confirm(confirmacion)) return;
        await axios.post("/api/producto_final", payload);
        alert("Producto creado con éxito");

        this.$emit("productoCreado");
      } catch (error) {
        console.error(error);
        alert("Error al guardar el producto. Por favor, inténtalo nuevamente.");
      }
    },
  },
  mounted() {
    this.clubActual=this.$store.getters.getClubActual;
    this.cargarTipos();
    this.cargarUnidades();
    this.cargarLotes();
    this.generarCodigo();
  },
};
</script>

<style scoped>
.cosechar {
  max-width: 600px;
  margin: auto;
}
.form-label {
  font-weight: bold;
}
.form-control,
.form-select {
  border: 1px solid #ced4da;
  border-radius: 5px;
}
.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}
.btn-success:hover {
  background-color: #218838;
  border-color: #1e7e34;
}
.codigo-label {
  font-weight: bold;
  font-size: 1.1rem;
  background-color: #e9ecef;
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ced4da;
  min-width: 120px;
  text-align: center;
}

/* Estilos para diferenciar los pasos */
.step-section {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  background-color: #fdfdfd;
}
.step-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.qr-update-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.qr-container {
  border: 2px solid #28a745;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  background-color: #fff;
}

.qr-code-label {
  margin-top: 8px;
  font-weight: bold;
  font-size: 1rem;
  color: #28a745;
}


</style>
